import Box from '@mui/material/Box';
import type { InnerReportFilter } from '../../../api/keys';
import { useRunReports } from '../../../api/run-report';
import { ReportTableView } from '../../table-view';

export interface ReportTableWidgetProps {
  filter: InnerReportFilter;
}

export function ReportTableWidget({ filter }: ReportTableWidgetProps) {
  const { data: reportData, isLoading } = useRunReports(filter);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        '& > .MuiPaper-root': {
          minHeight: 'auto !important',
          maxHeight: 'none !important',
        },
      }}
    >
      <ReportTableView isLoading={isLoading} reportData={reportData} />
    </Box>
  );
}
